import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb421d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_dialog_skeleton = _resolveComponent("dialog-skeleton")!

  return (_openBlock(), _createBlock(_component_dialog_skeleton, {
    "confirm-label": _ctx.t('STEP_2.BTN_GOT'),
    title: _ctx.t('STEP_2.IMPORT_INSTRUCTIONS', { objects: _ctx.t(`${_ctx.objectKey}.CAP.PLUR`) }),
    "cancel-label": _ctx.t('STEP_2.DOWNLOAD_TEMPLATE_BTN'),
    onCancel: _ctx.downloadTemplate,
    onConfirm: _ctx.close,
    ref: "dialog"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_q_card, { class: "instructions-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_scroll_area, {
            visible: false,
            class: "instructions-card-content"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, _normalizeProps(_guardReactiveProps(_ctx.TEXT_CONTENT_BODY)), {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "q-ma-sm",
                    innerHTML: _ctx.t(`STEP_2.INSTRUCTIONS.${_ctx.objectKey}`)
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["confirm-label", "title", "cancel-label", "onCancel", "onConfirm"]))
}